import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/landing';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-parchment py-14 md:py-28" data-id="element-45" data-mp="1bmllx5jgptjf">
      <div className="mx-auto grid max-w-6xl gap-6 px-5 md:gap-10 md:px-8 lg:grid-cols-[0.7fr_1.3fr] lg:gap-16" data-id="element-46" data-mp="1gitxya2d56md">
        <h2 className="text-center font-serif text-[1.9rem] font-semibold leading-tight text-ink sm:text-4xl md:text-5xl lg:text-left" data-id="element-47" data-mp="24ahga3lk79d1">
          Preguntas frecuentes
        </h2>
        <ul className="divide-y divide-line border-y border-line" data-id="element-48" data-mp="1uk6byfxyqy5m">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          const id = `faq-${i}`;
          return <li key={faq.question} data-id="element-49" data-mp="2n7sc1e7zfknq" data-mpi={i}>
                <h3 data-id="element-50" data-mp="2n6r3bgefva96">
                  <button type="button" aria-expanded={isOpen} aria-controls={id} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-4 text-left focus:outline-none focus-visible:text-gold-dark sm:gap-6 sm:py-6" data-id="element-51" data-mp="2n67m61wm4pw7">
                    <span className="font-serif text-lg font-semibold leading-tight text-ink sm:text-2xl" data-id="element-52" data-mp="1en6me8bx2fnh">
                      {faq.question}
                    </span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-53" data-mp="1ohyfozygugcg" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-54" data-mp="1skms1hme25e6">
                  {isOpen && <motion.div id={id} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-55" data-mp="35omjjxgi068">
                      <p className="max-w-2xl pb-4 text-[15px] leading-relaxed text-muted sm:pb-6 sm:text-lg" data-id="element-56" data-mp="287aog6q4dzym">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}